export const mockedGenders = [
    { id: 1, name: 'genders.male' },
    { id: 2, name: 'genders.female' },
    { id: 3, name: 'genders.autre' }
];
export const mockedLanguages = [
    { id: 1, name: 'languages.french', value: 'fr' },
    { id: 2, name: 'languages.english', value: 'en' }
];
